import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "./AuthContext";

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  /* `nacteno` odliší „profil ještě nedorazil“ od „profil není“ — Návrh podle
   * něj čeká s razítkem nového plánu na volby metodiky poradce (QA 18. 10. 2026). */
  const [nacteno, setNacteno] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setProfile(null); setNacteno(true); return; }
    setLoading(true);
    try {
      const res = await api.get("/api/profile/me");
      // country_code je NAD `profile` (je to vlastnost účtu, ne vizitky) — kdyby se
// sem nepropsal, formulář Nastavení by zemi vždy zobrazil jako výchozí CZ.
setProfile({ ...(res.data.profile || {}), name: res.data.name, email: res.data.email, role: res.data.role, country_code: res.data.country_code });
    } catch (e) {
      // Gracefully handle failures — profile is optional
      setProfile(null);
    } finally {
      setLoading(false);
      setNacteno(true);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const save = async (patch) => {
    const res = await api.put("/api/profile/me", patch);
    // country_code je NAD `profile` (je to vlastnost účtu, ne vizitky) — kdyby se
// sem nepropsal, formulář Nastavení by zemi vždy zobrazil jako výchozí CZ.
setProfile({ ...(res.data.profile || {}), name: res.data.name, email: res.data.email, role: res.data.role, country_code: res.data.country_code });
    return res.data;
  };

  return (
    <ProfileContext.Provider value={{ profile, loading, nacteno, refresh, save }}>
      {children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfile must be used inside ProfileProvider");
  return ctx;
};
